<template>
  <div class="ads-option">
    <header class="inner-header">
      
      <h2 style="color:#505050">
        कैसे पाए लिंक
      </h2>
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" @click="$emit('closeGetLinkOption')">
            <path
              fill="#727272"
              fill-rule="nonzero"
              d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
              opacity=".675"
            />
          </svg>
      <!-- <img src="../assets/images/backIcon.svg" alt="" @click="$emit('closeAdsOption')" /> -->
    </header>
    <div class="get-whatsapp-link">
        <div class="step">
            <div class="step-info">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                    <g fill="none" fill-rule="evenodd">
                        <g>
                            <g>
                                <g>
                                    <path fill="#1B7F1B" d="M3 3H13V13H3z" transform="translate(-16.000000, -77.000000) translate(16.000000, 71.000000) translate(0.000000, 6.000000)"/>
                                    <path fill="#44A944" d="M0 0H10V10H0z" transform="translate(-16.000000, -77.000000) translate(16.000000, 71.000000) translate(0.000000, 6.000000)"/>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
                <h4><strong>“WhatsApp Group Info”</strong> में जाएं। और आप <strong>“Invite via link”</strong> पर क्लिक करे। </h4>
                <img src="../assets/images/whatsapp-info.png" />
            </div>
            <div class="step-info">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                    <g fill="none" fill-rule="evenodd">
                        <g>
                            <g>
                                <g>
                                    <path fill="#1B7F1B" d="M3 3H13V13H3z" transform="translate(-16.000000, -77.000000) translate(16.000000, 71.000000) translate(0.000000, 6.000000)"/>
                                    <path fill="#44A944" d="M0 0H10V10H0z" transform="translate(-16.000000, -77.000000) translate(16.000000, 71.000000) translate(0.000000, 6.000000)"/>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
                <h4>अब, आपको कई विकल्प दिखेंगे जिसमे एक कॉपी लिंक का ऑप्शन होगा। अब, आप कॉपी लिंक विकल्प का उपयोग करके लिंक को कॉपी भी कर सकते है।  </h4>
                <img src="../assets/images/whatsapp-info2.png" />
            </div>
        </div>
    </div>
    <Toaster :dataValue="toasterData" />
  </div>
</template>
<script>
import Toaster from '../components/Toaster';
// import constants from "@/utils/constants";
export default {
  name: 'HowToGetLink',
  components: {
    Toaster,
  },
  data() {
    return {
      toasterData: {},
    };
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.ads-option{
    z-index: 999 !important;
}
.get-whatsapp-link{
    height: 100vh;
    overflow: scroll;
    padding-bottom: 50px;;
    .step-info{
        padding: 15px 35px 15px 55px;
    position: relative;
        svg{
            position: absolute;
            left: 15px;
            top: 20px;
        }
        h4{
            color: #505050;
            font-weight: normal;
            font-size: 0.875em;
                margin-bottom: 15px;
    line-height: 1.5em;
            strong{
                font-weight: 600;
            }
        }
    }
}
@import "@/assets/scss/splash";
</style>
